<template>
  <div
    class="owal env ui container"
  >
    <owal-panel
      title="Mask Reports"
      class="owal env ui panel"
    >
      <table class="w100">
        <thead>
          <tr>
            <th>Report Date</th>
            <th>Domain</th>
            <th>Google Sheet</th>
            <th>Approval</th>
            <th>Sent</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="report in reports" :key="report.id" class="owal__table">
            <td>{{new Date(report.created_at).toLocaleString('en-US')}}</td>
            <td>{{report.domain}}</td>
            <td><a :href="`https://docs.google.com/spreadsheets/d/${report.google_sheet_id}/`">Google Sheet</a></td>
            <td>
              <button v-if="!report.approved_at" @click="approveReport(report.id)">Approve</button>
              <span v-else>{{new Date(report.approved_at).toLocaleString()}}</span>
            </td>
            <td>
              <span v-if="!report.sent_at">Hasn't been sent yet</span>
              <span v-else>{{new Date(report.sent_at).toLocaleString()}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </owal-panel>
  </div>
</template>

<script>
import OwalPanel from '@/libraries/owal-ui/panels/OwalPanel'
import { loadReports, sendReportApproval } from '@/libraries/api/faces'
export default {
  name: 'MaskReport',
  components: {
    OwalPanel,
  },
  async mounted() {
    try {
      const data = await loadReports()
      this.reports = data.data.reports // [{created_at, approved_at, sent_at]
    } catch (e) {
      console.error(e)
    }
  },
  data () {
    return {
      reports: [],
    }
  },
  methods: {
    async approveReport(reportId) {
        const approved = await sendReportApproval(reportId)
        const newDate = approved.data.data[0]
        const idx = this.reports.findIndex(r => r.id === reportId)
        this.$set(this.reports, idx, { ...this.reports[idx], 'approved_at': newDate.ts })
    },
  },
}
</script>

<style scoped>
table {
   border-collapse: collapse; border-spacing: 0;
}
th, td {
  padding-left: 0;
  padding-right: 0;
}
tr:nth-child(even){
  background:lightgray;
}
tr:nth-child(even) > td{
  background:lightgray;
}
tr:nth-child(odd){

}

.owal.env.ui.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.owal.env.ui.panel {
  /* max-width: 68.5714285714rem; */
  margin: 1rem;
  max-height: 90%;
  max-width: 90vw;
  width: stretch;
  overflow: auto;
}

.owal.panel.active.window >>> .owal.panel.container {
  display: block;
}

.w100 {
  text-align: left;
  width: 100%;
}

</style>
